import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CardActions,
  Grid,
  Chip,
  IconButton,
  Stack
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import AddIcon from '@mui/icons-material/Add';
import MapModal from '../components/MapModal';

export default function Residences() {
  const navigate = useNavigate();
  const [residences, setResidences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mapOpen, setMapOpen] = useState(false);
  const [selectedResidence, setSelectedResidence] = useState(null);

  useEffect(() => {
    fetchResidences();
  }, []);

  const fetchResidences = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/residences', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      setResidences(data.residences || []);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLocationClick = (residence) => {
    setSelectedResidence(residence);
    setMapOpen(true);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight={600}>
          Gestion des Résidences
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/residences/new')}
        >
          Ajouter une résidence
        </Button>
      </Stack>

      <Grid container spacing={3}>
        {residences.map((residence) => (
          <Grid item xs={12} md={6} lg={4} key={residence.id}>
            <Card>
              <CardContent>
                <Stack spacing={2}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <ApartmentIcon />
                    <Typography variant="h6" fontWeight={600}>
                      {residence.name}
                    </Typography>
                    <IconButton onClick={() => navigate(`/residences/${residence.id}/edit`)}>
                      <SettingsIcon fontSize="small" />
                    </IconButton>
                  </Stack>

                  <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton
                      size="small"
                      onClick={() => handleLocationClick(residence)}
                      sx={{ p: 0.5 }}
                    >
                      <LocationOnIcon color="primary" />
                    </IconButton>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        {residence.address}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {residence.postalCode} {residence.city}
                      </Typography>
                    </Box>
                  </Stack>

                  <Stack direction="row" spacing={1}>
                    <Chip
                      icon={<ApartmentIcon />}
                      label={`${residence.numberOfApartments || 0} appartements`}
                      size="small"
                      variant="outlined"
                    />
                  </Stack>
                </Stack>
              </CardContent>

              <CardActions>
                <Button size="small" onClick={() => navigate(`/residences/${residence.id}`)}>
                  Voir détails
                </Button>
                <Button
                  size="small"
                  startIcon={<PeopleIcon />}
                  onClick={() => navigate(`/residences/${residence.id}/tenants`)}
                >
                  Locataires
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <MapModal
        open={mapOpen}
        address={selectedResidence?.address}
        name={selectedResidence?.name}
	postalCode={selectedResidence?.postalCode}
        city={selectedResidence?.city}
        onClose={() => setMapOpen(false)}
      />
    </Box>
  );
}
